module.exports = __webpack_public_path__ + "img/NEO.0d34f17f.svg";